import { FeatureFlagObject } from "../services";

export const getFFEnabled = (
  flagName: string,
  featureFlags: FeatureFlagObject[] | undefined
) =>
  featureFlags?.find((ff: FeatureFlagObject) => ff.flag_name === flagName)
    ?.enabled || false;
